import { Route, Routes } from "react-router";
import * as Pages from "pages";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Home route to wrap all routes */}
      <Route element={<Pages.Home />}>

        {/* Dashboard route */}
        <Route path="/" element={<Pages.Dashboard />} />

        {/* Tickets route */}
        <Route path="/tickets" element={<Pages.Tickets />} />
        <Route path="/tickets/:id" element={<Pages.TicketDetails />} />

        {/* Customers route */}
        <Route path="/customers" element={<Pages.Customers />} />
        <Route path="/customers/:id" element={<Pages.CustomerDetails />} />

        {/* Reporting route */}
        <Route path="/reporting" element={<Pages.Reports />} />

        {/* Chats route */}
        <Route path="/chats" element={<Pages.Chats />} />

        {/* Chats route */}
        <Route path="/feedbacks" element={<Pages.Feedbacks />} />

        {/* Settings Route */}
        <Route path="/settings" element={<Pages.Settings />} />
      </Route>

      {/* Login Route */}
      <Route path="/login" element={<Pages.Login />} />
      
      {/* Catch all route */}
      <Route path="*" element={<Pages.NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
